import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@shared/base/base.component';
import { ICardDetailBody } from '@models/card.model';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-card-detail-body',
  templateUrl: './card-detail-body.component.html',
  styleUrls: ['./card-detail-body.component.scss'],
})
export class CardDetailBodyComponent extends BaseComponent implements OnInit {
  @Input() title: string;
  @Input() titleInBody = false;
  @Input() bodyList: ICardDetailBody[];
  @Input() cardClasses: string = 'mt-7';
  @Input() cardHeaderClasses: string;
  @Input() loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  constructor() {
    super();
  }

  ngOnInit(): void {}

  protected readonly decodeURIComponent = decodeURIComponent;
}
